import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import heroImage from "./../../../assets/images/adanced-growhair6.jpg";
import favicon from "./../../../assets/images/favicon.ico";

import "./advancedhair.css";
//bannerimg
import growhair1 from "./../../../assets/images/adanced-growhair.jpg";
//before and after
import growhair2 from "./../../../assets/images/advanced-growhair7.jpg";
import growhair3 from "./../../../assets/images/advanced-growhair8.jpg";
import growhair4 from "./../../../assets/images/advanced-growhair9.jpg";

// Import icons
import groHairIcon from "./../../../assets/images/grow-hair treatment-icons.png";
import prpIcon from "./../../../assets/images/prp-treatment-icons1.png";
import gfcIcon from "./../../../assets/images/gfc-treatment-icons.png";
import stmIcon from "./../../../assets/images/treatment.png";
import laserIcon from "./../../../assets/images/laserhair.png";
import AutoScrollImageRow from "./AutoScrollImageRow";


const treatments = [
  { name: "GROHAIR TREATMENT", navName: "GROHAIR" },
  { name: "PRP TREATMENT", navName: "PRP" },
  { name: "GFC TREATMENT", navName: "GFC" },
  { name: "STM TREATMENT", navName: "STM" },
  { name: "LASER TREATMENT", navName: "LASER" },
];

const treatmentIconPNGMap = {
  GROHAIR: groHairIcon,
  PRP: prpIcon,
  GFC: gfcIcon,
  STM: stmIcon,
  LASER: laserIcon,
};

const images = [
  { 
    src: growhair2, 
    alt: "Before GroHair Treatment - Patient with visible hair thinning", 
    title: "Hair Loss Before GroHair Treatment at H-Cura Clinic"
  },
  { 
    src: growhair3, 
    alt: "After GroHair Treatment - Same patient with improved hair density", 
    title: "Successful Hair Regrowth Results After H-Cura GroHair Treatment"
  },
  { 
    src: growhair4, 
    alt: "Before GroHair Treatment - Patient with pattern baldness", 
    title: "Male Pattern Baldness Before Advanced Hair Treatment"
  }
];

const faqData = [
  {
    q: "Is GroHair Treatment painful?",
    a: "A numbing cream is applied before treatment to minimize discomfort. Most patients describe it as mild and tolerable.",
  },
  {
    q: "How soon will I see results?",
    a: "Reduced hair fall is usually noticeable within 3–4 sessions, with visible hair regrowth in 8–12 weeks.",
  },
  {
    q: "How many sessions are required?",
    a: "Typically 6–10 sessions, but this depends on individual hair loss patterns.",
  },
  {
    q: "Is it safe?",
    a: "Yes, our treatment uses FDA-approved serums and is performed by experienced doctors.",
  },
];

function Hair() {
  const [activeTab, setActiveTab] = useState("GFC TREATMENT");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.title =
      "GROHAIR Treatment & Advanced Hair Regrowth Therapy - H-Cura";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Boost your hair growth with GROHAIR Treatment at H-Cura, Bangalore and Chennai. Experience advanced, non-invasive therapy for thicker, healthier hair. Book your consultation today."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "GroHair treatment in Bangalore,Advanced hair regrowth therapy,Best hair growth treatment in Bangalore,Non-invasive hair regrowth solutions,Hair loss treatment Bangalore,Effective hair restoration therapy,Hair thinning solutions Bangalore,Scalp rejuvenation treatment,"
      );
    }
    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-grow-hair-treatment"
      );
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-grow-hair-treatment"
      );
      document.head.appendChild(canonicalLink);
    }
    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }

    // 1. FAQPage Schema
    const scriptFaq = document.createElement("script");
    scriptFaq.type = "application/ld+json";
    scriptFaq.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqData.map((faq) => ({
        "@type": "Question",
        "name": faq.q,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.a,
        },
      })),
    });
    document.head.appendChild(scriptFaq);

    // 2. LocalBusiness Schema (Enhanced)
    const scriptBusiness = document.createElement("script");
    scriptBusiness.type = "application/ld+json";
    scriptBusiness.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "MedicalClinic",
      "name": "H-Cura Multispecialty Clinic",
      "image": "https://www.h-cura.com/static/media/adanced-growhair6.jpg",
      "telephone": "+91-8870001377",
      "email": "info@h-cura.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "H-Cura Homeopathy Multispecialty Clinic No:779&780 2nd Floor, Sai Towers Building, South, E End Main Rd, Bengaluru, Karnataka 560069, India",
        "addressLocality": "Bangalore",
        "addressRegion": "Karnataka",
        "postalCode": "560069",
        "addressCountry": "IN"
      },
      "url": "https://www.h-cura.com/advanced-grow-hair-treatment",
      "priceRange": "₹₹",
      "openingHours": "Mo-Sa 10:00-19:00",
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 12.9257,
        "longitude": 77.5838
      },
      "sameAs": [
        "https://www.facebook.com/hcuraclinic",
        "https://www.instagram.com/hcuraclinic/"
      ],
      "medicalSpecialty": ["Trichology", "Hair Restoration"],
      "availableService": ["Hair Loss Treatment", "GroHair Therapy", "PRP Treatment", "GFC Treatment", "STM Treatment", "Laser Treatment"],
      "award": "Best Hair Restoration Clinic in Bangalore 2024"
    });
    document.head.appendChild(scriptBusiness);

    // 3. Product Schema for GroHair Treatment
    const scriptProduct = document.createElement("script");
    scriptProduct.type = "application/ld+json";
    scriptProduct.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Advanced GroHair Treatment",
      "description": "Advanced GroHair Treatment is a needle-based mesotherapy that involves using microinjections to infuse a powerful blend of hair growth stimulants directly into your scalp.",
      "brand": {
        "@type": "Brand",
        "name": "H-Cura"
      },
      "offers": {
        "@type": "Offer",
        "priceCurrency": "INR",
        "price": "10000",
        "priceValidUntil": "2025-12-31",
        "availability": "https://schema.org/InStock"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "156"
      },
      "review": [
        {
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "bestRating": "5"
          },
          "author": {
            "@type": "Person",
            "name": "Rahul Sharma"
          },
          "datePublished": "2024-05-15",
          "reviewBody": "I've tried many hair loss treatments before, but GroHair Treatment at H-Cura has given me real results. My hair is noticeably thicker after just 6 sessions."
        }
      ]
    });
    document.head.appendChild(scriptProduct);

    // 4. MedicalProcedure Schema
    const scriptMedicalProcedure = document.createElement("script");
    scriptMedicalProcedure.type = "application/ld+json";
    scriptMedicalProcedure.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "MedicalProcedure",
      "name": "GroHair Treatment",
      "procedureType": "https://schema.org/TherapeuticProcedure",
      "bodyLocation": "Scalp",
      "preparation": "Comprehensive consultation and scalp analysis",
      "followup": "Regular monitoring and maintenance sessions",
      "howPerformed": "Non-invasive mesotherapy with growth factors applied directly to the scalp",
      "procedureDescription": "Advanced GroHair Treatment is a needle-based mesotherapy that involves using microinjections to infuse a powerful blend of hair growth stimulants directly into your scalp.",
      "treatmentIndication": ["Hair thinning", "Male pattern baldness", "Female pattern baldness", "Post-pregnancy hair loss", "Stress-induced hair loss"],
      "potentialComplication": ["Mild scalp sensitivity", "Temporary redness"],
      "status": "Available",
      "relevantSpecialty": {
        "@type": "MedicalSpecialty",
        "name": "Trichology"
      }
    });
    document.head.appendChild(scriptMedicalProcedure);

    // 5. BreadcrumbList Schema
    const scriptBreadcrumb = document.createElement("script");
    scriptBreadcrumb.type = "application/ld+json";
    scriptBreadcrumb.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.h-cura.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Treatments",
          "item": "https://www.h-cura.com/treatments"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Advanced GroHair Treatment",
          "item": "https://www.h-cura.com/advanced-grow-hair-treatment"
        }
      ]
    });
    document.head.appendChild(scriptBreadcrumb);

    // 6. WebPage Schema
    const scriptWebPage = document.createElement("script");
    scriptWebPage.type = "application/ld+json";
    scriptWebPage.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "GROHAIR Treatment & Advanced Hair Regrowth Therapy - H-Cura",
      "description": "Boost your hair growth with GROHAIR Treatment at H-Cura, Bangalore and Chennai. Experience advanced, non-invasive therapy for thicker, healthier hair. Book your consultation today.",
      "url": "https://www.h-cura.com/advanced-grow-hair-treatment",
      "speakable": {
        "@type": "SpeakableSpecification",
        "cssSelector": [".hc-hero-content", ".hc-what-is-grohair-inner"]
      },
      "primaryImageOfPage": {
        "@type": "ImageObject",
        "contentUrl": "https://www.h-cura.com/static/media/adanced-growhair6.jpg",
        "description": "Advanced GroHair Treatment for Hair Restoration at H-Cura Clinic",
        "name": "H-Cura GroHair Treatment Hero Image"
      },
      "lastReviewed": "2024-06-01",
      "mainContentOfPage": {
        "@type": "WebPageElement",
        "cssSelector": ".hc-wrapper"
      }
    });
    document.head.appendChild(scriptWebPage);

    // 7. Organization Schema
    const scriptOrganization = document.createElement("script");
    scriptOrganization.type = "application/ld+json";
    scriptOrganization.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "H-Cura Multispecialty Clinic",
      "url": "https://www.h-cura.com",
      "logo": "https://www.h-cura.com/static/media/logo.png",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+91-8870001377",
          "contactType": "customer service",
          "areaServed": ["Bangalore", "Chennai"],
          "availableLanguage": ["English", "Hindi", "Tamil", "Kannada"]
        }
      ],
      "sameAs": [
        "https://www.facebook.com/hcuraclinic",
        "https://www.instagram.com/hcuraclinic/",
        "https://twitter.com/hcuraclinic"
      ]
    });
    document.head.appendChild(scriptOrganization);

    // 8. ImageGallery Schema for Before/After Images
    const scriptImageGallery = document.createElement("script");
    scriptImageGallery.type = "application/ld+json";
    scriptImageGallery.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ImageGallery",
      "about": "Hair Treatment Before and After Results",
      "image": images.map(image => ({
        "@type": "ImageObject",
        "contentUrl": image.src,
        "description": image.alt,
        "name": image.title
      }))
    });
    document.head.appendChild(scriptImageGallery);

    // 9. HowTo Schema for Treatment Process
    const scriptHowTo = document.createElement("script");
    scriptHowTo.type = "application/ld+json";
    scriptHowTo.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "HowTo",
      "name": "How GroHair Treatment Works",
      "description": "Step-by-step process of the GroHair Treatment at H-Cura Clinic",
      "totalTime": "PT60M",
      "estimatedCost": {
        "@type": "MonetaryAmount",
        "currency": "INR",
        "value": "10000"
      },
      "supply": [
        {
          "@type": "HowToSupply",
          "name": "Growth factor serum"
        },
        {
          "@type": "HowToSupply",
          "name": "Numbing cream"
        }
      ],
      "tool": [
        {
          "@type": "HowToTool",
          "name": "Mesotherapy device"
        },
        {
          "@type": "HowToTool",
          "name": "Scalp analysis equipment"
        }
      ],
      "step": [
        {
          "@type": "HowToStep",
          "name": "Comprehensive Consultation",
          "text": "Begin your transformation with a detailed assessment by our expert trichologists.",
          "image": "https://www.h-cura.com/static/media/consultation-image.jpg",
          "url": "https://www.h-cura.com/advanced-grow-hair-treatment#consultation"
        },
        {
          "@type": "HowToStep",
          "name": "Personalized Treatment Design",
          "text": "Receive a custom-tailored treatment plan designed specifically for your needs.",
          "image": "https://www.h-cura.com/static/media/treatment-design-image.jpg",
          "url": "https://www.h-cura.com/advanced-grow-hair-treatment#design"
        },
        {
          "@type": "HowToStep",
          "name": "Advanced Treatment Session",
          "text": "Experience H-Cura's state-of-the-art growth factor therapy.",
          "image": "https://www.h-cura.com/static/media/treatment-session-image.jpg",
          "url": "https://www.h-cura.com/advanced-grow-hair-treatment#session"
        },
        {
          "@type": "HowToStep",
          "name": "Comprehensive Aftercare",
          "text": "Ensure optimal results with our dedicated follow-up program.",
          "image": "https://www.h-cura.com/static/media/aftercare-image.jpg",
          "url": "https://www.h-cura.com/advanced-grow-hair-treatment#aftercare"
        }
      ]
    });
    document.head.appendChild(scriptHowTo);

    // 10. MedicalCondition Schema for Hair Loss
    const scriptMedicalCondition = document.createElement("script");
    scriptMedicalCondition.type = "application/ld+json";
    scriptMedicalCondition.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "MedicalCondition",
      "name": "Hair Loss (Alopecia)",
      "alternateName": ["Baldness", "Hair Thinning", "Androgenetic Alopecia"],
      "description": "Hair loss (alopecia) can affect just your scalp or your entire body, and it can be temporary or permanent. It can be the result of heredity, hormonal changes, medical conditions or a normal part of aging.",
      "possibleTreatment": {
        "@type": "MedicalTherapy",
        "name": "GroHair Treatment",
        "url": "https://www.h-cura.com/advanced-grow-hair-treatment"
      },
      "associatedAnatomy": {
        "@type": "AnatomicalStructure",
        "name": "Scalp"
      },
      "typicalTest": [
        "Scalp Analysis",
        "Hair Follicle Examination",
        "Blood Tests for Hormonal Imbalances"
      ],
      "riskFactor": [
        "Genetic factors",
        "Aging",
        "Hormonal changes",
        "Medical conditions",
        "Medications",
        "Stress"
      ]
    });
    document.head.appendChild(scriptMedicalCondition);

    // 11. Article Schema for the Main Content
    const scriptArticle = document.createElement("script");
    scriptArticle.type = "application/ld+json";
    scriptArticle.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "Advanced GroHair Treatment: Revolutionary Hair Growth Technology",
      "description": "Advanced GroHair Treatment is a needle-based mesotherapy that involves using microinjections to infuse a powerful blend of hair growth stimulants directly into your scalp.",
      "image": {
        "@type": "ImageObject",
        "url": "https://www.h-cura.com/static/media/adanced-growhair6.jpg",
        "caption": "Advanced GroHair Treatment at H-Cura Clinic"
      },
      "datePublished": "2024-01-15T08:00:00+05:30",
      "dateModified": "2024-06-01T10:30:00+05:30",
      "author": {
        "@type": "Organization",
        "name": "H-Cura Multispecialty Clinic"
      },
      "publisher": {
        "@type": "Organization",
        "name": "H-Cura Multispecialty Clinic",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.h-cura.com/static/media/logo.png"
        }
      },
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://www.h-cura.com/advanced-grow-hair-treatment"
      }
    });
    document.head.appendChild(scriptArticle);

    // 12. SpecialAnnouncement Schema for Promotions or COVID Safety
    const scriptSpecialAnnouncement = document.createElement("script");
    scriptSpecialAnnouncement.type = "application/ld+json";
    scriptSpecialAnnouncement.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "SpecialAnnouncement",
      "name": "Special Offer on GroHair Treatment",
      "text": "Book your GroHair Treatment consultation this month and receive a complimentary hair care kit worth INR 2,000.",
      "datePosted": "2024-07-01T09:00:00+05:30",
      "expires": "2024-07-31T23:59:59+05:30",
      "category": "https://schema.org/MedicalBusiness",
      "announcementLocation": {
        "@type": "MedicalClinic",
        "name": "H-Cura Multispecialty Clinic",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "No:779&780 2nd Floor, Sai Towers Building, South, E End Main Rd",
          "addressLocality": "Bangalore",
          "addressRegion": "Karnataka",
          "postalCode": "560069",
          "addressCountry": "IN"
        }
      }
    });
    document.head.appendChild(scriptSpecialAnnouncement);

    // 13. VideoObject Schema (if you have a treatment video)
    const scriptVideo = document.createElement("script");
    scriptVideo.type = "application/ld+json";
    scriptVideo.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "VideoObject",
      "name": "GroHair Treatment Process at H-Cura",
      "description": "Watch how our advanced GroHair Treatment works to stimulate natural hair growth and restore hair density.",
      "thumbnailUrl": "https://www.h-cura.com/static/media/video-thumbnail.jpg",
      "uploadDate": "2024-03-15T08:00:00+05:30",
      "contentUrl": "https://www.h-cura.com/videos/grohair-treatment-process.mp4",
      "embedUrl": "https://www.youtube.com/embed/abc123xyz",
      "duration": "PT3M42S",
      "interactionStatistic": {
        "@type": "InteractionCounter",
        "interactionType": { "@type": "WatchAction" },
        "userInteractionCount": 5647
      }
    });
    document.head.appendChild(scriptVideo);

    // 14. Service Schema for Each Treatment Type
    const treatmentServices = treatments.map(treatment => ({
      "@context": "https://schema.org",
      "@type": "MedicalService",
      "name": `${treatment.name}`,
      "serviceType": "Hair Restoration",
      "provider": {
        "@type": "MedicalClinic",
        "name": "H-Cura Multispecialty Clinic",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "No:779&780 2nd Floor, Sai Towers Building, South, E End Main Rd",
          "addressLocality": "Bangalore",
          "addressRegion": "Karnataka",
          "postalCode": "560069",
          "addressCountry": "IN"
        }
      },
      "serviceOutput": "Improved hair density and reduced hair loss",
      "areaServed": ["Bangalore", "Chennai"],
      "availableChannel": {
        "@type": "ServiceChannel",
        "serviceUrl": `https://www.h-cura.com/${treatment.name.toLowerCase().replace(/\s+/g, "-")}`,
        "servicePhone": "+91-8870001377",
        "serviceSmsNumber": "+91-8870001377"
      }
    }));

    treatmentServices.forEach((serviceSchema, index) => {
      const scriptService = document.createElement("script");
      scriptService.type = "application/ld+json";
      scriptService.innerHTML = JSON.stringify(serviceSchema);
      scriptService.id = `service-schema-${index}`;
      document.head.appendChild(scriptService);
    });

    // 15. Person Schema for Testimonials
    const scriptTestimonial = document.createElement("script");
    scriptTestimonial.type = "application/ld+json";
    scriptTestimonial.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Person",
      "name": "Rahul Sharma",
      "review": {
        "@type": "Review",
        "reviewBody": "I've tried many hair loss treatments before, but GroHair Treatment at H-Cura has given me real results. My hair is noticeably thicker after just 6 sessions.",
        "itemReviewed": {
          "@type": "MedicalProcedure",
          "name": "GroHair Treatment",
          "procedureType": "https://schema.org/TherapeuticProcedure"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        }
      }
    });
    document.head.appendChild(scriptTestimonial);

    // 16. Event Schema for Consultation Booking
    const scriptEvent = document.createElement("script");
    scriptEvent.type = "application/ld+json";
    scriptEvent.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Event",
      "name": "Free Hair Loss Consultation",
      "description": "Book a free consultation with our hair restoration specialists to discuss your hair loss concerns and treatment options.",
      "startDate": "2024-07-01T10:00:00+05:30",
      "endDate": "2024-07-31T19:00:00+05:30",
      "eventStatus": "https://schema.org/EventScheduled",
      "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
      "location": {
        "@type": "Place",
        "name": "H-Cura Multispecialty Clinic",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "No:779&780 2nd Floor, Sai Towers Building, South, E End Main Rd",
          "addressLocality": "Bangalore",
          "addressRegion": "Karnataka",
          "postalCode": "560069",
          "addressCountry": "IN"
        }
      },
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock",
        "validFrom": "2024-07-01",
        "url": "https://www.h-cura.com/bookconsultation"
      },
      "organizer": {
        "@type": "Organization",
        "name": "H-Cura Multispecialty Clinic",
        "url": "https://www.h-cura.com"
      }
    });
    document.head.appendChild(scriptEvent);

    // Original effect code for process steps
    const steps = document.querySelectorAll(".hc-process-step");
    steps.forEach((step, index) => {
      step.style.setProperty("--index", index);
      step.style.opacity = "1";
    });

    // Cleanup on unmount
    return () => {
      document.head.removeChild(scriptFaq);
      document.head.removeChild(scriptBusiness);
      document.head.removeChild(scriptProduct);
      document.head.removeChild(scriptMedicalProcedure);
      document.head.removeChild(scriptBreadcrumb);
      document.head.removeChild(scriptWebPage);
      document.head.removeChild(scriptOrganization);
      document.head.removeChild(scriptImageGallery);
      document.head.removeChild(scriptHowTo);
      document.head.removeChild(scriptMedicalCondition);
      document.head.removeChild(scriptArticle);
      document.head.removeChild(scriptSpecialAnnouncement);
      document.head.removeChild(scriptVideo);
      document.head.removeChild(scriptTestimonial);
      document.head.removeChild(scriptEvent);
      
      // Remove service schemas
      treatmentServices.forEach((_, index) => {
        const serviceScript = document.getElementById(`service-schema-${index}`);
        if (serviceScript) {
          document.head.removeChild(serviceScript);
        }
      });
    };
  }, []);

  useEffect(() => {
    // Get the current path from window.location
    const path = window.location.pathname;
    if (path.includes("advanced-grow-hair-treatment")) {
      setActiveTab("GROHAIR TREATMENT");
    } else {
      const pathSegments = path.split("/");
      const currentPage = pathSegments[pathSegments.length - 1]?.toLowerCase();
      if (currentPage) {
        const matchingTreatment = treatments.find(
          (treatment) => treatment.navName.toLowerCase() === currentPage
        );
        if (matchingTreatment) {
          setActiveTab(matchingTreatment.name);
        }
      }
    }
  }, []);

  const renderTreatmentIcon = (name, fallbackIcon) => {
    const baseName = name.split(" ")[0];
    return treatmentIconPNGMap[baseName] ? (
      <img
        src={treatmentIconPNGMap[baseName]}
        alt={`${name} icon`}
        title={`${name} Treatment Icon`}
        style={{ width: "100px", height: "100px" }}
      />
    ) : (
      fallbackIcon
    );
  };

  const openModal = (image) => {
        setModalImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage(null);
  };

  const handleTreatmentClick = (name) => {
    setActiveTab(name);
    const treatmentUrlMap = {
      "GROHAIR TREATMENT": "/advanced-grow-hair-treatment",
      "PRP TREATMENT": "/advanced-hair-prp-treatment",
      "GFC TREATMENT": "/advanced-hair-gfc-treatment",
      "STM TREATMENT": "/advanced-stm-treatment",
      "LASER TREATMENT": "/advanced-laser-treatment",
    };
    const url =
      treatmentUrlMap[name] || `/home/${name.split(" ")[0].toLowerCase()}`;
    navigate(url);
  };

  return (
    <div className="hc-wrapper">
      {/* New Navigation Section */}
      <div className="hc-treatment-nav-container">
        <h2>Explore Our Treatments</h2>
        <div className="hc-treatment-nav-cards">
          {treatments.map((treatment) => {
            const [treatmentName, treatmentSuffix] = treatment.name.split(" ");
            return (
              <div
                key={treatment.name}
                className={`hc-treatment-nav-card ${
                  activeTab === treatment.name ? "active" : ""
                }`}
                style={{
                  position: "relative",
                  borderBottom:
                    activeTab === treatment.name ? "3px solid #007bff" : "none",
                  transition: "border-bottom 0.3s ease",
                }}
                onClick={() => handleTreatmentClick(treatment.name)}
              >
                <div className="hc-card-icon">
                  {renderTreatmentIcon(treatment.navName)}
                </div>
                <div className="hc-card-title">
                  <span style={{ color: "#007bff" }}>{treatmentName}</span>{" "}
                  {treatmentSuffix}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Hero Section */}
      <section
        className="hc-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroImage})`,

        }}
        role="img"
        aria-label="Advanced GroHair Treatment at H-Cura Clinic"
          title="Advanced GroHair Treatment Banner at H-Cura Clinic"
      >
        <div className="hc-hero-content">
          <h1 className="hc-hero-title">
            Advanced GroHair Treatment in Bangalore & Chennai
          </h1>
          <p className="hc-hero-text">
            Experience Revolutionary Gro Hair Therapy
          </p>
          <Link
            to="/bookconsultation"
            style={{ textDecoration: "none" }}
            className="hc-cta-button"
          >
            Book Consultation
          </Link>
        </div>
      </section>

      {/* Treatment Section */}
      <section className="hc-treatment-section" id="treatments">
        <div className="hc-treatment-container">
          <div className="hc-treatment-nav">
            <h2>Help Your Hair with Our Advanced Treatments</h2>
            <p className="hc-nav-description">
              From growth factor enhancements to exclusive Grohair therapies,
              each treatment is engineered to kickstart your natural hair
              regrowth.
            </p>
            <ul>
              <li className="hc-active">
                <strong>Gro Hair Therapy</strong>
                <p>Stimulate hair follicles & helps in hair regrowth .</p>
                <ul className="hc-treatment-details">
                  <li>painless proess & noninvasive procedure</li>
                  <li>helps in control hairfall</li>
                  <li>Quick visible results</li>
                  <li>reduce dandruff</li>
                </ul>
              </li>
              <li className="hc-active">
                <strong>Growth Factor Therapy</strong>
                <p>Stimulate hair follicles & helps in hair regrowth .</p>
                <ul className="hc-treatment-details">
                  <li>Clinical proven and tested</li>
                  <li>Minimal procedure</li>
                  <li>Quick visible results</li>
                  <li>
                    Enrich with Biotin , Zinc , Minerals and other Vitamins
                  </li>
                </ul>
              </li>
              <li>
                <strong>PRP Therapy</strong>
                <p>
                  Restore your hair naturally by plasma rich protein therapy.
                </p>
                <ul className="hc-treatment-details">
                  <li>Autologous treatment</li>
                  <li>No synthetic additives</li>
                  <li>Boosts regeneration</li>
                </ul>
              </li>
              <li>
                <strong>Stem Cell Treatment</strong>
                <p>Rejuvenate your hair using regenerative technology.</p>
                <ul className="hc-treatment-details">
                  <li>Based on plant poly peptides </li>
                  <li>Supports tissue repair</li>
                  <li>Long-lasting results</li>
                </ul>
              </li>
              <li>
                <strong>Laser Hair Therapy</strong>
                <p>Enhance hair density with precision laser treatments.</p>
                <ul className="hc-treatment-details">
                  <li>Pain-free procedure</li>
                  <li>It stimulate hair follicles</li>
                  <li>hair boosting therapy</li>
                  <li>Quick sessions</li>
                </ul>
              </li>
            </ul>
            <p className="hc-treatment-description-text">
              Our state-of-the-art therapies are administered by experienced
              specialists.
            </p>
            <p className="hc-treatment-extra-info">
              Book a consultation today to create your personalized treatment
              plan.
            </p>
          </div>

          <div className="hc-treatment-content">
            <h3>
              {" "}
              Regrow Your Hair Naturally with Advanced GroHair Therapy at H‑Cura
            </h3>
            <div className="hc-treatment-info">
              <div className="hc-treatment-images">
                <img
                  src={growhair1}
                  alt="Advanced GroHair Treatment Process at H-Cura Clinic"
                  title="State-of-the-art Hair Restoration Therapy"
                  className="hc-main-treatment-image"
                />
                <div className="hc-treatment-gallery">
                  {images.map((image, index) => (
                    <img
                      key={index}
                      src={image.src}
                      alt={image.alt}
                      title={image.title}
                      onClick={() => openModal(image)}
                    />
                  ))}
                </div>
                <div className="hc-treatment-highlight-info">
                  Experience scientifically proven, needle-free, non-invasive
                  hair regrowth with Advanced GroHair Treatment at H‑Cura
                  Multispecialty Clinic. Now available at our Jayanagar
                  (Bangalore) and Valasaravakkam (Chennai) branches, this
                  FDA-approved French electroporation therapy delivers
                  nourishing serums and DHT blockers directly into the scalp,
                  promoting hair volume, thickness, and confidence—all without
                  injections or surgery.
                </div>
              </div>

              <div className="hc-treatment-description">
                <h4>Revolutionary Hair Growth Technology</h4>
                <div className="hc-treatment-intro">
                  <Link
                    to="/bookconsultation"
                    style={{ textDecoration: "none" }}
                  >
                    <span className="hc-highlight-tag">Advanced Treatment</span>
                  </Link>
                  <p className="hc-lead-text">
                    Experience the future of hair restoration with our
                    FDA-approved Growth Factor Treatment.
                  </p>
                </div>

                <div className="hc-key-benefits">
                  <h5>How It Transforms Your Hair</h5>
                  <p>
                    Our scientifically proven treatment utilizes advanced growth
                    factors and natural proteins to:
                  </p>
                  <ul>
                    <li>
                      <span className="hc-benefit-icon">🔬</span>
                      <strong>Stimulate hair Follicles</strong>
                      <p>Reactivates sleeping hair follicles for new growth</p>
                    </li>
                    <li>
                      <span className="hc-benefit-icon">📈</span>
                      <strong>Increase Hair Density</strong>
                      <p>Up to 40% improvement in hair thickness</p>
                    </li>
                    <li>
                      <span className="hc-benefit-icon">🌱</span>
                      <strong>Natural Hair Growth</strong>
                      <p>Promotes sustainable, natural-looking results</p>
                    </li>
                    <li>
                      <span className="hc-benefit-icon">💪</span>
                      <strong>Strengthen Existing Hair</strong>
                      <p>Reduces breakage and improves hair quality</p>
                    </li>
                  </ul>
                </div>

                <div className="hc-treatment-highlights">
                  <div className="hc-highlight-box">
                    <h5>Success Rate</h5>
                    <p>95%</p>
                    <span className="hc-subtitle">Satisfied Clients</span>
                  </div>
                  <div className="hc-highlight-box">
                    <h5>Treatment Time</h5>
                    <p>60 mins</p>
                    <span className="hc-subtitle">Per Session</span>
                  </div>
                  <div className="hc-highlight-box">
                    <h5>Recovery</h5>
                    <p>min to max</p>
                    <span className="hc-subtitle">
                      depends upon person to person{" "}
                    </span>
                  </div>
                  <div className="hc-highlight-box">
                    <h5>Result</h5>
                    <p>6-10 sessions</p>
                    <span className="hc-subtitle">for visible results</span>
                  </div>
                </div>

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                  <button className="hc-book-treatment-btn">
                    Schedule Your Consultation
                    <span className="hc-btn-icon">→</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hc-what-is-grohair">
        <div className="hc-what-is-grohair-inner">
          <h2 className="hc-what-is-grohair-title">
            What is Advanced GroHair Treatment?
          </h2>
          <p className="hc-what-is-grohair-desc">
            Advanced GroHair Treatment is a needle-based mesotherapy that involves using microinjections to infuse a powerful blend of hair growth stimulants directly into your scalp. These nutrients nourish hair follicles, strengthen roots, and rejuvenate dormant follicles to promote natural hair regrowth.
          </p>
          <p className="hc-what-is-grohair-desc">
            This treatment is an effective, non-surgical solution for individuals experiencing:
          </p>
          <ul className="hc-what-is-grohair-list">
            <li>Hair thinning and reduced volume</li>
            <li>Male or female pattern baldness (Androgenetic Alopecia)</li>
            <li>Post-pregnancy hair loss</li>
            <li>Stress or hormonal hair fall</li>
          </ul>
          <p className="hc-what-is-grohair-desc">
            At H‑Cura, we combine the latest technology with expert medical care to deliver excellent results safely and comfortably.
          </p>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="hc-benefits-section">
        <div className="hc-benefits-header">
          <span className="hc-section-tag">Why Choose Us</span>
          <h2>Experience Excellence with H-Cura Multispeciality clinic</h2>
          <p className="hc-section-subtitle">
            Our advanced treatments combine cutting-edge science with
            personalized care to restore your hair and confidence.
          </p>
        </div>

        <div className="hc-benefits-grid">
          {[
            {
              icon: "🔬",
              title: "State-of-the-Art Technology",
              desc: "We deploy the latest in growth factor technology and FDA-approved treatments to ensure optimal hair restoration results.",
              features: [
                "Latest Medical Innovation",
                "Proven Clinical Results",
                "Safe & Effective",
              ],
            },
            {
              icon: "👨‍⚕",
              title: "Expert Medical Team",
              desc: "Our board-certified specialists bring decades of experience in advanced hair restoration techniques.",
              features: [
                "Certified Specialists",
                "Ongoing Training",
                "Dedicated Care Team",
              ],
            },
            {
              icon: "🎯",
              title: "Personalized Treatment",
              desc: "Every treatment plan is tailored to your unique hair type, condition, and desired outcomes.",
              features: [
                "Custom Solutions",
                "Regular Monitoring",
                "Adaptive Care Plans",
              ],
            },
            {
              icon: "✨",
              title: "Natural Results",
              desc: "Experience transformative results that look and feel completely natural, boosting your confidence.",
              features: [
                "Lasting Results",
                "Natural Appearance",
                "High Success Rate",
              ],
            },
            {
              icon: "🛡",
              title: "Safety First Approach",
              desc: "H-Cura prioritizes your safety with stringent protocols and state-of-the-art facilities.",
              features: [
                "Medical-Grade Facility",
                "Sterile Environment",
                "Safety Protocols",
              ],
            },
            {
              icon: "💯",
              title: "Proven Track Record",
              desc: "Join thousands of clients who have experienced the H-Cura difference in hair restoration.",
              features: [
                "95% Success Rate",
                "10000+ Happy Clients",
                "Outstanding Reviews",
              ],
            },
          ].map((benefit, index) => (
            <div className="hc-benefit-card" key={index}>
              <div className="hc-benefit-icon">{benefit.icon}</div>
              <div className="hc-benefit-content">
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
                <ul className="hc-feature-list">
                  {benefit.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Process Section */}
      <section className="hc-process-section" id="process">
        <div className="hc-process-header">
          <span className="hc-process-tag">Our Process</span>
          <h2>Your Journey to Fuller Hair with H-Cura</h2>
          <p className="hc-process-subtitle">
            Experience our comprehensive 4-step approach to hair restoration
          </p>
        </div>

        <div className="hc-process-timeline">
          {[
            {
              step: "01",
              title: "Comprehensive Consultation",
              desc: "Begin your transformation with a detailed assessment by our expert trichologists.",
              details: [
                "Advanced scalp analysis",
                "Hair loss pattern evaluation",
                "Medical history review",
                "Treatment expectations discussion",
              ],
              icon: "🔍",
            },
            {
              step: "02",
              title: "Personalized Treatment Design",
              desc: "Receive a custom-tailored treatment plan designed specifically for your needs.",
              details: [
                "Growth factor concentration optimization",
                "Treatment schedule planning",
                "Expected timeline discussion",
                "Lifestyle recommendations",
              ],
              icon: "📋",
            },
            {
              step: "03",
              title: "Advanced Treatment Session",
              desc: "Experience H-Cura's state-of-the-art growth factor therapy.",
              details: [
                "Sterile environment preparation",
                "Growth factor application",
                "Scalp stimulation therapy",
                "Comfort-focused procedure",
              ],
              icon: "💉",
            },
            {
              step: "04",
              title: "Comprehensive Aftercare",
              desc: "Ensure optimal results with our dedicated follow-up program.",
              details: [
                "Progress monitoring",
                "Treatment adjustments",
                "Maintenance guidelines",
                "Long-term care planning",
              ],
              icon: "📈",
            },
          ].map((process, index) => (
            <div className="hc-process-step" key={index} id={index === 0 ? "consultation" : index === 1 ? "design" : index === 2 ? "session" : "aftercare"}>
              <div className="hc-step-container">
                <div className="hc-step-number-container">
                  <div className="hc-step-number">{process.step}</div>
                  <div className="hc-step-icon">{process.icon}</div>
                </div>
                <div className="hc-step-content">
                  <h3>{process.title}</h3>
                  <p className="hc-step-description">{process.desc}</p>
                  <ul className="hc-step-details">
                    {process.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {index < 3 && <div className="hc-connector-line"></div>}
            </div>
          ))}
        </div>
      </section>

      {/* FAQ Section */}
      <section className="hc-faq-section">
        <div className="hc-faq-header">
          <span className="hc-section-tag">FAQs</span>
          <h2 className="hc-faq-title">Frequently Asked Questions</h2>
        </div>
        <div className="hc-faq-list" itemScope itemType="https://schema.org/FAQPage">
          {faqData.map((faq, idx) => (
            <details className="hc-faq-item" key={idx} itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
              <summary className="hc-faq-question" itemProp="name">
                <span className="hc-faq-q">Q{idx + 1}:</span> {faq.q}
                <span className="hc-faq-toggle-icon">+</span>
              </summary>
              <div className="hc-faq-answer" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                <span className="hc-faq-a">A:</span> <span itemProp="text">{faq.a}</span>
              </div>
            </details>
          ))}
        </div>
      </section>
      <AutoScrollImageRow />

      {/* Modal for Image Viewing */}
      {isModalOpen && (
        <div className="hc-modal-overlay" onClick={closeModal}>
          <div
            className="hc-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="hc-close-modal" onClick={closeModal} aria-label="Close image preview">
              &times;
            </button>
            <img
              src={modalImage.src}
              alt={modalImage.alt}
              title={modalImage.title}
              className="hc-modal-image"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Hair;
